var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 255.1 141.7",
    style: {
      enableBackground: "new 0 0 255.1 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7d90a4;}\n\t.st1{font-family:'Kalivo-Black';}\n\t.st2{font-size:108px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "full_logo"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 28.2208 94.8752)",
    className: "st0 st1 st2"
  }, "nona"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_00000132805356628854055790000017974678354407877818_"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrey);
export default __webpack_public_path__ + "static/media/logo_grey.492ec64582a85900a035d9455fb6fa07.svg";
export { ForwardRef as ReactComponent };